// extracted by mini-css-extract-plugin
module.exports = {"fileContainer":"UploadFile_fileContainer__2wAGY"};